<template>
  <div>
    <van-pull-refresh v-model="is_refresh" @refresh="onRefresh">
      <van-list v-model="is_loading"
                :finished="is_load_finished"
                :immediate-check="false"
                finished-text="没有更多了"
                :error.sync="is_error"
                error-text="请求失败，点击重新加载"
                @load="onLoad">
        <project-item :project="{
            articles:item.project.articles,
            project_id:item.project.project_id,
            is_multi:item.project.articles.length>1,
            avatar:item.project.articles[0].article.writer.avatar.web_path,
            category:item.project.project_category,
            title:item.project.project_title,
            content_visible:item.project.articles[0].article.article_content_visible,
            price:item.project.project_price,
            borwser_num:item.project.project_borwser_num,
            state:item.project.project_state
          }" v-for="(item, index) in list" :key="item.project_id">
        </project-item>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
    import ProjectItem from '@/views/components/ProjectItem'
    export default {
        name: 'myproject',
        components:{
          ProjectItem
        },
        data() {
            return {
                page: 0,
                list: [],
                is_error: false,
                is_refresh: false,
                is_loading: false,
                is_load_finished: false,
                is_cancel:false
            }
        },
        created: function () {
            this.page = 1;
            this.getData(this.page, false)
        },
        mounted:function(){

        },
        methods: {
            onRefresh() {
                this.select_value = '';
                this.page = 1;
                this.is_load_finished = false;
                this.getData(this.page, true)
            },
            onLoad() {
                this.page++;
                this.getData(this.page, false);

            },
            getData: function (page, refresh) {
                let that = this;
                this.weapi.request({
                    url: 'buyed_project',
                    method: 'get',
                    params: {page:page},
                }).then(res => {
                    if (res.data.code === '200') {
                        let _list = res.data.data.list;
                        if (refresh) {
                            that.list = [];
                            that.$toast('刷新成功！');
                            that.is_refresh = false;
                        }
                        if (that.page <= 1) {
                            that.list = [];
                        }
                        for (let i = 0; i < _list.length; i++) {
                            that.list.push(_list[i]);
                        }
                        if (res.data.data.end) {
                            that.is_load_finished = true;
                        }
                    }
                    else {
                        that.is_refresh = false;
                        that.is_error = true;
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                    that.is_refresh = false;
                    that.is_error = true;
                }).finally(function (response) {
                    that.is_loading = false;
                })
            },
        }
    }
</script>
<style>

  .my-swipe .van-swipe-item {
    color: #fff;
    line-height: 150px;
    text-align: center;
    background-color: #39a9ed;
  }

  .my-swipe .swipe-img {
    width: 100%;
  }

  .article-wrap{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

  }
  .article-wrap .game-over{
    position: absolute;
    right: 10px;
  }
  .article-content-wrap{
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }
  .tongji-wrap{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-right: 20px;
  }
  .tongji-wrap span{
    margin-left: 5px;
  }
  /*.van-list{*/
    /*margin:10px;*/
    /*border-radius: 4px;*/
  /*}*/
</style>
